import { OPEN_MODAL, CLOSE_MODAL, SET_COMPONENT } from 'actions/modal';


import Immutable from 'immutable';


const initialState = Immutable.Map({
	modalOpen : false,
	onClose : false,
	message : null,
    component: false,
	title : null,
	actionBtnText: null,
	ackOnly : null,
	className: null
});


export default (state = initialState, action) => {

	switch (action.type) {
		case OPEN_MODAL: {
			if(action.payload.component) {
				state = state.set('component', action.payload.component);
			}
			if(action.payload.props) {

				if(action.payload.props.onClose) {
					state = state.set('onClose', action.payload.props.onClose);
				}

				if(action.payload.props.message) {
					state = state.set('message', action.payload.props.message);
				}

				if(action.payload.props.className) {
					state = state.set('className', action.payload.props.className);
				}

				if(action.payload.props.title) {
					state = state.set('title', action.payload.props.title);
				}

				if(action.payload.props.ackOnly) {
					state = state.set('ackOnly', action.payload.props.ackOnly);
				}
				else{
					state = state.set("ackOnly", false);
				}

				if(action.payload.props.actionBtnText) {
					state = state.set('actionBtnText', action.payload.props.actionBtnText);
				}
				else{
					state = state.set("actionBtnText", 'Delete');
				}
			}

			state = state.set('modalOpen', true);
			break;
		}

		case CLOSE_MODAL: {
		    state = state.set('modalOpen', false);
			state = initialState;
			break;
		}

		case SET_COMPONENT: {
			state = initialState;
			break;
		}
	}
	return state;
};


// WEBPACK FOOTER //
// ./js/reducers/modal.js